import Beacons from 'modules/beacons/utils';
import { QuartileKey } from 'tag/models/common/common';

export const midpointListener = (adserverRequestId: string) => {
  Beacons.fire.videoQuartile(QuartileKey.Q50, adserverRequestId, true);
};
